import * as React from 'react'

import { cn } from '@/lib/utils'

export type PageHeaderProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> & {
  title: React.ReactNode
  description?: React.ReactNode
  actions?: React.ReactNode
}

/** 页面顶部标准头部：统一标题层级、描述与右侧操作区布局。 */
export function PageHeader({ title, description, actions, className, ...props }: PageHeaderProps) {
  return (
    <div className={cn('flex items-start justify-between gap-4', className)} {...props}>
      <div className="min-w-0 space-y-1">
        <h1 className="truncate text-2xl font-semibold leading-none tracking-tight">{title}</h1>
        {description ? (
          <div className="text-sm leading-5 text-muted-foreground">{description}</div>
        ) : null}
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
    </div>
  )
}
